import React from 'react';
import images from '../../assets/images';

const InterestImgCheckbox = ({interest, handleCheckbox}) => {
  return (
    <div className="interests--container--list--item">
      <input checked={interest.checked} onChange={(e) => handleCheckbox(e,interest)} className="interests--container--list--item--checkbox--input" type="checkbox" id={`checkboxImage${interest.id}`} />
      <label className="interests--container--list--item--checkbox" htmlFor={`checkboxImage${interest.id}`}>
        <img className="interests--container--list--item--checkbox--main-img" src={interest.icon} />
        <img className="interests--container--list--item--checkbox--check-img" src={images.iconChecked} alt="Check Icon" />
      </label>
      <div className="interests--container--list--item--checkbox--text">{interest.title}</div>
    </div>
  );
};

export default InterestImgCheckbox;
